import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { ObservationPointVMEdit, SchematicDataVMEdit } from '../setup-implement/setup-implement.model';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-schematic-op-popup-edit-all',
  templateUrl: './schematic-op-popup-edit-all.component.html',
  styleUrls: ['./schematic-op-popup-edit-all.component.scss']
})
export class SchematicOpPopupEditAllComponent implements OnInit {

  positionX: string = "200";
  positionY: string = "50";
 schematic: SchematicDataVMEdit = new SchematicDataVMEdit();
   title: string = "Schematic";

  //@Input() mouseoverMPId: number = 0;
  mouseoverOPId: number = 0;
   currentStep: number = 0;

  eventX: number
    eventY: number
    //  window.
    showSchematic: boolean = false;
    schematicPositionX: number;
    schematicPositionY: number;

    // Mouse events for draggable schematic window.
    isMouseDown: boolean = false;
    prevMouseX: number;
    prevMouseY: number;
    selectedSchematic: SchematicDataVMEdit;

    showAddObservation: boolean = false
    mouseclick: boolean = false

    TempObservationPoints:ObservationPointVMEdit[]
    obsDetails:ObservationPointVMEdit[]
    //crack data
    TypeID:number
    startXY: string;
    endXY: string;
    isStartEdit: boolean = false;
    isEndEdit: boolean = false;
    EndeventX: number
    EndeventY: number
    Compname: string;
    obserationID:number
    findEditObsPoint:ObservationPointVMEdit[] 
    findRestObsPoint:ObservationPointVMEdit[] 


  constructor(private _sanitizer: DomSanitizer,
    public openObservationPointModel: MatDialog,
    public dialogRef: MatDialogRef<SchematicOpPopupEditAllComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,
    private _implementService: SetupImplementService,
    private _notify: NotificationsService,) { }

 
    ngOnInit() {
      this.schematic=this.data.schematic
      this.mouseoverOPId=this.data.mouseoverOPId
      this.currentStep=this.data.currentStep
      this.obserationID=this.data.obserationID

      this.findEditObsPoint = this.schematic.ObservationPoints.filter(f=>f.Id ==this.obserationID)
      this.findRestObsPoint = this.schematic.ObservationPoints.filter(f=>f.Id !=this.obserationID)
      this.TempObservationPoints = this.findEditObsPoint;
          if (this.schematic.ImageName != null) {
              this.title = this.schematic.ImageName;
          }
  
          
          console.log("this.findRestObsPoint", this.findRestObsPoint)
          this.Compname=  this.findEditObsPoint[0].Name
          this.eventX= this.findEditObsPoint[0].PositionX
          this.eventY= this.findEditObsPoint[0].PositionY
          this.startXY =  this.findEditObsPoint[0].PositionX.toString() + " ," +  this.findEditObsPoint[0].PositionY.toString();
          this.endXY =  this.findEditObsPoint[0].PositionXEnd.toString() + " ," +  this.findEditObsPoint[0].PositionYEnd.toString();
          this.EndeventX= this.findEditObsPoint[0].PositionXEnd
          this.EndeventY= this.findEditObsPoint[0].PositionYEnd
          console.log("EndeventX", this.EndeventX)
          console.log("EndeventY", this.EndeventY)
          console.log("startXY", this.startXY)

          console.log("endXY", this.endXY)

    
         console.log("startXY",this.startXY)
    console.log("endXY", this.endXY)
    console.log(" this.mouseoverOPId",  this.mouseoverOPId)
    }

    getImage(image: string) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  
  setWindowPosition(posX: string, posY: string) {
      return this._sanitizer.bypassSecurityTrustStyle('Left: ' + posX + 'px;' + 'Top: ' + posY + 'px;' + 'Position: absolute; z-index: 10;');
  }
  
  
  getPosition(posX: string, posY: string) {
    var iPX = (parseFloat(posX));
    var iPY = (parseFloat(posY));
    return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;z-inde:1');
  }  
  
  ClearCurrentStartXY() {
      this.startXY = null;
      this.isStartEdit = true;
      this.isEndEdit = false;
      
    }
  
    ClearCurrentEndXY() {
      this.endXY = null;
      this.isStartEdit = false;
      this.isEndEdit = true;
    }
  
    ConfirmStartXY(){
      this.startXY = this.eventX.toString() + " ," + this.eventY.toString();
      console.log("data", this.eventX + " ," + this.eventY)
  
      this.isStartEdit= false;
  
      var colour ="#EC0A0A";
      
    }
    ConfirmEndXY(){
      console.log(this.EndeventX,+"event xy"+ this.EndeventY)
      this.endXY = this.EndeventX.toString() + " ," + this.EndeventY.toString();
      console.log("data wnd ", this.EndeventX + " ," + this.EndeventY)
      this.isEndEdit= false;
    }
    isNew:boolean=false
  
    openObservationPointModal(event) {
  
      console.log(this.getEval(1,"tt"))
      this.isNew==true
  
       console.log("open obsercation point modal", event)
       console.log("openthis.currentStep", this.currentStep)
       //this.RemoveTempOP()
       if ((this.schematic.Id > 0) && (this.currentStep == 2)) {
       if (this.findEditObsPoint[0].ObservationType!="Crack") {
         console.log("isNew IF", this.isNew)
         this.showAddObservation = true;
         this.AddTempOP(event);
         this.eventX = event.offsetX - 10;
         this.eventY = event.offsetY - 10;
         this.mouseclick = true
        
       } else {
        console.log("isNew ELSE", this.isNew)
         this.showAddObservation = true;
         this.AddTempOP_Crack(event);
         //this.eventX = event.offsetX - 10;
        // this.eventY = event.offsetY - 10;
         this.mouseclick = true
       }
     }
     }
  
  
    onCloseClick(): void {
        this.dialogRef.close();
    }
  
  
    getEval(wornPct: number, inspectDate: string) {
     //console.log(this.isNew)
      if(this.isNew==true)
        {
          
            return 'magenta'      
          
        }
        
        else {

          return 'gray';
       // }
        }
        
    }
    getEvalEdit(wornPct: number, inspectDate: string) {
     // console.log(this.isNew)
      if(this.isNew==true)
        {
          
            return 'green'      
          
        }
        
        else {

          return 'gray';
       // }
        }
        
    }

  
    onMouseOverMP(id) {
       // this.mouseoverMP.emit(id);
    }
  
    onMouseOutMP(id) {
       // this.mouseoverMP.emit(0);
    }
  
    onMouseOverOP(id) {
       // this.mouseoverOP.emit(id);
    }
  
    onMouseOutOP() {
      //  this.mouseoverOP.emit(0);
    }
  
  
      
        AddTempOP_Crack(event) {
          console.log("this.findEditObsPoint;", this.findEditObsPoint)
          this.TempObservationPoints = this.findEditObsPoint;
          let arr_ = [];
      
          if(this.TempObservationPoints != null){
            if (this.TempObservationPoints.find(x => x.Id == -1)) {
              let val =this.TempObservationPoints.find(x => x.Id == -1);
              if(this.isStartEdit){
                this.eventX = event.offsetX - 10;
                this.eventY = event.offsetY - 10;
      
                val.PositionX = event.offsetX - 10;
                val.PositionY = event.offsetY - 10;
              }else{
                val.PositionXEnd = event.offsetX - 10;
                val.PositionYEnd = event.offsetY - 10;
      
                this.EndeventX = event.offsetX - 10;
                this.EndeventY = event.offsetY - 10;
              }
            }else{
              var tempOP: ObservationPointVMEdit = new ObservationPointVMEdit();
              if(this.isStartEdit){
                tempOP.PositionX = event.offsetX - 10;
                tempOP.PositionY = event.offsetY - 10;
                this.eventX = event.offsetX - 10;
                this.eventY = event.offsetY - 10;
              
              }else{
                tempOP.PositionXEnd = event.offsetX - 10;
                tempOP.PositionYEnd = event.offsetY - 10;
                this.EndeventX = event.offsetX - 10;
                this.EndeventY = event.offsetY - 10;
            
              }
              tempOP.isCrackFixed=false;
              tempOP.Id = -1;
            //  tempOP.observationPointTypeId = this.TypeID;
              tempOP.IsNew = true;
              arr_.push(tempOP);
          
              if (this.TempObservationPoints != null && this.TempObservationPoints.length > 0) {
                this.TempObservationPoints.push(tempOP)
              } else {
                this.TempObservationPoints = arr_;
              }
              this.obsDetails = this.TempObservationPoints;
            }
          }
          
        }
    
  
  
        AddTempOP(event) {
          this.TempObservationPoints = this.findEditObsPoint;
          let arr_ = [];
          this.RemoveTempOP();
          var tempOP: ObservationPointVMEdit = new ObservationPointVMEdit();
          tempOP.PositionX = event.offsetX - 10;
          tempOP.PositionY = event.offsetY - 10;
          tempOP.Id = -1;
         // tempOP.observationPointTypeId = this.TypeID;
         tempOP.IsNew = true;
          arr_.push(tempOP);
      
          if (this.TempObservationPoints != null && this.TempObservationPoints.length > 0) {
            this.TempObservationPoints.push(tempOP)
          } else {
            this.TempObservationPoints = arr_;
          }
          this.findEditObsPoint = this.TempObservationPoints;
        }
      
        RemoveTempOP() {
          if (this.TempObservationPoints != null) {
            if (this.TempObservationPoints.find(x => x.Id == -1)) {
              this.TempObservationPoints.splice(this.TempObservationPoints.findIndex(x => x.IsNew == true), 1);
            }
          }
          this.TempObservationPoints = this.findEditObsPoint;
         
      }
    
        editObservation()
        {
          
  
              // if (this.isFECRCrack == true) {
              //   this.TypeID = 6
              // } else if (this.isFECRNormal) {
              //   this.TypeID = 5
              // }
              var saveParams: ObservationPointVMEdit = new ObservationPointVMEdit();
              saveParams.Name =this.Compname;      
              console.log("this.schematic.ObservationPoints",this.findEditObsPoint[0].Id)
              saveParams.Id=  this.obserationID       
              saveParams.PositionX = this.eventX
              saveParams.PositionY = this.eventY                  
              saveParams.PositionXEnd = (this.findEditObsPoint[0].ObservationType=="Crack")?this.EndeventX:null;
              saveParams.PositionYEnd=(this.findEditObsPoint[0].ObservationType=="Crack")?this.EndeventY:null;
           
          
              
              this._implementService.UpdateObservationPoints(saveParams).subscribe(res => {
          
                if (res == true) {
                 // this.OPId = res
                 
                 this._notify.success('Observation saved successfully!');
  
                  this.dialogRef.close(true)
                }
                else {
                  this._notify.error('Save Unsuccessful');
                
                }
          
              })
          
            
          
        }
  
        getLine(posX: string, posY: string, EndposX: string, EndposY: string,isCrackFixed:boolean) {
          // bottom right
          var x1 = (parseFloat(posX));
          var y1 = (parseFloat(posY));
          // top right
          var x2 = (parseFloat(EndposX));
          var y2 = (parseFloat(EndposY));
          // distance
          var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
          // center
          var cx = (((x1 + x2) / 2) - (length / 2)) + 7;
          var cy = ((y1 + y2) / 2) - (4 / 2);
          // angle
          var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);
          // make hr
      
          var colour =isCrackFixed==false?"#EC0A0A":"#4472C4";
          return this._sanitizer.bypassSecurityTrustStyle('padding:0px; margin:0px; height:' + 4 + 
          'px; background-color:' +colour + '; line-height:1px; position:absolute; left:' + cx + 
          'px; top:' + cy + 'px; width:' + length + 'px; -moz-transform:rotate(' + angle + 'deg); -webkit-transform:rotate(' + angle + 'deg); -o-transform:rotate(' + angle + 'deg); -ms-transform:rotate(' + angle + 'deg); transform:rotate(' + angle + 'deg);');
         
           }
  }
  
